// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__pIuvY","formContainer":"menu_formContainer__38mw-","checkboxContainer":"menu_checkboxContainer__2S7EX"};